































import AppComboboxSingle from '@/uikit/components/AppComboBox/AppComboboxSingle.vue';
import AppComboboxMulti from '@/uikit/components/AppComboBox/AppComboboxMulti.vue';
export default {
  name: 'AppComboBox',
  components: { AppComboboxMulti, AppComboboxSingle },

  props: {
    data: {
      type: Array,
    },
    value: [String, Number, Array],
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    isEnableSort: {
      type: Boolean,
      default: false,
    },
    multi: {
      type: Boolean,
      default: false,
    },
    notEmpty: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: [Boolean, String],
      default: false,
      validator: (value: any) => typeof value === 'boolean' || value === 'auto',
    },
    error: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: undefined,
    },
    checkForm: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectData(data: any) {
      this.$emit('input', data);
    },
    validate(data: any) {
      this.$emit('validate', data);
    },
  },
  computed: {
    getStyle() {
      let ret: any = {};
      if (this.readonly) {
        ret['--root-combobox-pointer-events'] = 'none';
      }
      return ret;
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppComboBox/AppComboBox.vue